import axios from '@/utils/http.js';

const urls = {
  addProject: '/project/insert',
  queryProject: '/project/load',
  deleteProject: '/project/delete',
  updateProject: '/project/update',
};

export const addProject = function (options) {
  options.url = urls.addProject;
  return axios.post(options);
};
export const queryProject = function (options) {
  options.url = urls.queryProject;
  return axios.get(options);
};
export const deleteProject = function (options) {
  options.url = urls.deleteProject;
  return axios.delete(options);
};
export const updateProject = function (options) {
  options.url = urls.updateProject;
  return axios.post(options);
};
